import FilterOptions from '../models/FilterOptions';
import { FETCH_FILTER_OPTIONS } from '../actions/ActionTypes';
export default function filterOptions(state = new FilterOptions(), action) {
  switch (action.type) {
    case FETCH_FILTER_OPTIONS:
      return action.meta === 'request' ? state : FilterOptions.fromJS(action.payload);
    default:
      return state;
  }
}